import { NumberFormatValues, SourceInfo } from 'react-number-format';
import { useCallback } from 'react';
import { useQuoteBuilderActions } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/form-context';
import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/view';

import { useQuoteBuilderModalState } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/modal-context';
import Input from '@paradigm/design-system/src/components/Input';
import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';

function PriceField() {
  const { price, fieldsValidation, side } = useQuoteBuilderView();
  const { changePrice } = useQuoteBuilderActions();
  const { legPricingEnabled } = useQuoteBuilderModalState();
  const { didSubmit } = useSubmitted();
  const isMobile = useIsMobile();
  const trackAction = useDebouncedTrackAction();
  const handleOnChange = useCallback(
    ({ formattedValue }: NumberFormatValues, sourceInfo: SourceInfo): void => {
      if (sourceInfo.source === 'event')
        trackAction('change strategy price', { side });
      changePrice(formattedValue);
    },
    [changePrice, side, trackAction],
  );
  return (
    <Input
      id="grfq-quote-builder-price-input"
      data-testid="grfq-quote-builder-price-input"
      label="Price"
      inputType="numeric"
      size={isMobile ? 'large' : 'medium'}
      decimalScale={price.precision}
      allowLeadingZeros
      value={price.value}
      warning={!fieldsValidation.price && didSubmit}
      inputMode="decimal"
      thousandSeparator
      disabled={legPricingEnabled}
      onValueChange={handleOnChange}
    />
  );
}

export default PriceField;
